import { useState } from 'react';
import { Truck, ChevronDown } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';
import { Checkbox } from '../ui/checkbox';
import { Button } from '../ui/button';
import { Input } from '../ui/input';

export const VehicleMultiFilter = ({ vehicles, selected, onChange }) => {
  const [q, setQ] = useState('');
  const shown = vehicles.filter((v) => v.includes(q.trim().toUpperCase().replace(/\s+/g, '')));
  const toggle = (v) => onChange(selected.includes(v) ? selected.filter((x) => x !== v) : [...selected, v]);
  const label = selected.length === 0 ? 'All vehicles' : selected.length === 1 ? selected[0] : `${selected.length} vehicles`;

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline" className="min-w-[180px] justify-between" data-testid="verify-vehicle-filter-btn">
          <span className="flex items-center gap-2"><Truck className="h-4 w-4" /> {label}</span>
          <ChevronDown className="h-4 w-4 opacity-60" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-64 p-2" align="start">
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search registration…" className="h-8 mb-2" data-testid="verify-vehicle-search" />
        <label className="flex items-center gap-2 px-2 py-1.5 rounded hover:bg-slate-100 cursor-pointer text-sm font-semibold">
          <Checkbox checked={selected.length === 0} onCheckedChange={() => onChange([])} data-testid="verify-vehicle-all" />
          All vehicles
        </label>
        <div className="max-h-64 overflow-y-auto">
          {shown.map((v) => (
            <label key={v} className="flex items-center gap-2 px-2 py-1.5 rounded hover:bg-slate-100 cursor-pointer text-sm font-mono">
              <Checkbox checked={selected.includes(v)} onCheckedChange={() => toggle(v)} data-testid={`verify-vehicle-opt-${v}`} />
              {v}
            </label>
          ))}
          {shown.length === 0 && <p className="text-xs text-slate-500 px-2 py-2">No matching vehicles</p>}
        </div>
      </PopoverContent>
    </Popover>
  );
};
